var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4569_10123)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10.3V15.3L14 17.8V30.8L12.5 33.3H12V37.3H9V40.3H36V37.3H33V33.3H32.5L31 30.8V17.8L34 15.3V10.3H30V12.3H25V10.3H20V12.3H15V10.3H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15.3H10.25C10.25 15.5226 10.3489 15.7337 10.5199 15.8762L11 15.3ZM11 10.3V9.55005C10.5858 9.55005 10.25 9.88584 10.25 10.3H11ZM14 17.8H14.75C14.75 17.5775 14.6511 17.3664 14.4801 17.2239L14 17.8ZM14 30.8L14.6431 31.1859C14.7131 31.0694 14.75 30.936 14.75 30.8H14ZM12.5 33.3V34.05C12.7634 34.05 13.0076 33.9118 13.1431 33.6859L12.5 33.3ZM12 33.3V32.55C11.5858 32.55 11.25 32.8858 11.25 33.3H12ZM12 37.3V38.05C12.4142 38.05 12.75 37.7143 12.75 37.3H12ZM9 37.3V36.55C8.58579 36.55 8.25 36.8858 8.25 37.3H9ZM9 40.3H8.25C8.25 40.7143 8.58579 41.05 9 41.05V40.3ZM36 40.3V41.05C36.4142 41.05 36.75 40.7143 36.75 40.3H36ZM36 37.3H36.75C36.75 36.8858 36.4142 36.55 36 36.55V37.3ZM33 37.3H32.25C32.25 37.7143 32.5858 38.05 33 38.05V37.3ZM33 33.3H33.75C33.75 32.8858 33.4142 32.55 33 32.55V33.3ZM32.5 33.3L31.8569 33.6859C31.9924 33.9118 32.2366 34.05 32.5 34.05V33.3ZM31 30.8H30.25C30.25 30.936 30.2869 31.0694 30.3569 31.1859L31 30.8ZM31 17.8L30.5199 17.2239C30.3489 17.3664 30.25 17.5775 30.25 17.8H31ZM34 15.3L34.4801 15.8762C34.6511 15.7337 34.75 15.5226 34.75 15.3H34ZM34 10.3H34.75C34.75 9.88584 34.4142 9.55005 34 9.55005V10.3ZM30 10.3V9.55005C29.5858 9.55005 29.25 9.88584 29.25 10.3H30ZM30 12.3V13.05C30.4142 13.05 30.75 12.7143 30.75 12.3H30ZM25 12.3H24.25C24.25 12.7143 24.5858 13.05 25 13.05V12.3ZM25 10.3H25.75C25.75 9.88584 25.4142 9.55005 25 9.55005V10.3ZM20 10.3V9.55005C19.5858 9.55005 19.25 9.88584 19.25 10.3H20ZM20 12.3V13.05C20.4142 13.05 20.75 12.7143 20.75 12.3H20ZM15 12.3H14.25C14.25 12.7143 14.5858 13.05 15 13.05V12.3ZM15 10.3H15.75C15.75 9.88584 15.4142 9.55005 15 9.55005V10.3ZM11.75 15.3V10.3H10.25V15.3H11.75ZM10.5199 15.8762L13.5199 18.3762L14.4801 17.2239L11.4801 14.7239L10.5199 15.8762ZM13.25 17.8V30.8H14.75V17.8H13.25ZM13.3569 30.4142L11.8569 32.9142L13.1431 33.6859L14.6431 31.1859L13.3569 30.4142ZM12.5 32.55H12V34.05H12.5V32.55ZM11.25 33.3V37.3H12.75V33.3H11.25ZM12 36.55H9V38.05H12V36.55ZM8.25 37.3V40.3H9.75V37.3H8.25ZM9 41.05H36V39.55H9V41.05ZM36.75 40.3V37.3H35.25V40.3H36.75ZM36 36.55H33V38.05H36V36.55ZM33.75 37.3V33.3H32.25V37.3H33.75ZM33 32.55H32.5V34.05H33V32.55ZM33.1431 32.9142L31.6431 30.4142L30.3569 31.1859L31.8569 33.6859L33.1431 32.9142ZM31.75 30.8V17.8H30.25V30.8H31.75ZM31.4801 18.3762L34.4801 15.8762L33.5199 14.7239L30.5199 17.2239L31.4801 18.3762ZM33.25 10.3V15.3H34.75V10.3H33.25ZM30 11.05H34V9.55005H30V11.05ZM30.75 12.3V10.3H29.25V12.3H30.75ZM25 13.05H30V11.55H25V13.05ZM24.25 10.3V12.3H25.75V10.3H24.25ZM20 11.05H25V9.55005H20V11.05ZM20.75 12.3V10.3H19.25V12.3H20.75ZM15 13.05H20V11.55H15V13.05ZM14.25 10.3V12.3H15.75V10.3H14.25ZM11 11.05H15V9.55005H11V11.05Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 39.3H36V36.3H9V39.3Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 32.3L14 29.8H31L32.5 32.3H12.5Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 36.3V32.3H33V36.3H12Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 29.8V16.8H31V29.8H14Z",
    stroke: "#141414",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.8L11 14.3H34L31 16.8H14Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.3V9.30005H15V11.3H20V9.30005H25V11.3H30V9.30005H34V14.3H11Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35.8H33",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 31.8H32",
    stroke: "white",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 29.8H31",
    stroke: "white",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.8H31",
    stroke: "white",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.3H34",
    stroke: "white",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4569_10123",
    x: 7.25,
    y: 9.55005,
    width: 30.5,
    height: 33.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4569_10123"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4569_10123",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/br.e72f9de793eff06033b074d2b8b6b8a1.svg";
export { ForwardRef as ReactComponent };